export class KonkursaiFormCtrl {
    constructor($scope, $http, $timeout) {
        'ngInject';
        this.$scope = $scope;
        this.$http = $http;
        this.$timeout = $timeout;

        const g = (typeof window !== 'undefined') ? window : {};

        this.mode = g.formMode || 'create';
        this.submitUrl = g.formSubmitUrl || '';
        this.backUrl = g.formBackUrl || '';
        this.selects = g.formSelects || {institucijos: [], kryptys: [], pareigybes: [], active: []};
        this.model = g.formItem ? {...g.formItem} : {};
        this.publishConfirm = g.formPublishConfirm || '';

        const toDate = (v) => {
            if (!v || v === '0') {
                return null;
            }
            if (typeof v === 'number') {
                return new Date(v * 1000);
            }
            if (typeof v === 'string' && /^\d+$/.test(v)) {
                return new Date(parseInt(v, 10) * 1000);
            }
            const ts = Date.parse(v);
            return isNaN(ts) ? null : new Date(ts);
        };

        this.model.active = ('active' in this.model) ? this.model.active : 0;

        const toNumber = (v) => {
            if (v === null || v === undefined || v === '') {
                return null;
            }
            const n = parseFloat(String(v).replace(',', '.'));
            return isNaN(n) ? null : n;
        };
        this.model.etatas = toNumber(this.model.etatas);

        this.model.dateObj = toDate(this.model.date) || null;
        this.model.termObj = toDate(this.model.terminas) || null;

        this._attLimit = 4;
        const raw = (g.formAttachments || g.formAtachments || []);
        this.attachments = raw
            .filter(x => x && x.data && x.data.filesystem_id)
            .map(x => ({...x, name: x.name || ('file' + (x.nr || '1'))}));

        this.canAddAttachment = () => this.attachments.filter(a => !a._removed).length < this._attLimit;

        this.addAttachment = () => {
            if (!this.canAddAttachment()) {
                return;
            }
            let maxNum = 0;
            this.attachments.forEach((a) => {
                const m = /^file(\d+)$/.exec(a && a.name ? String(a.name) : '');
                if (m) {
                    const n = parseInt(m[1], 10);
                    if (!isNaN(n) && n > maxNum) {
                        maxNum = n;
                    }
                }
            });
            const next = Math.max(maxNum + 1, this.attachments.length + 1);
            this.attachments.push({name: 'file' + next});
        };

        this.removeAttachment = (index) => {
            const item = this.attachments[index];
            if (!item) {
                return;
            }
            if (item.data && item.data.filesystem_id) {
                item._removed = true;
                item.del = 'on';
            } else {
                this.attachments.splice(index, 1);
            }
        };

        this.onFilePickedFromEl = (ev) => {
            const el = ev && ev.target ? ev.target : null;
            if (!el) {
                return;
            }
            const slot = el.getAttribute('data-att');
            const file = el.files && el.files[0];
            if (!slot || !file) {
                return;
            }
            const idx = this.attachments.findIndex(a => a && a.name === slot);
            if (idx >= 0) {
                this.attachments[idx]._fileName = file.name;
                this.attachments[idx]._removed = false;
                this.attachments[idx].del = false;
            }
            this.$scope.$applyAsync();
        };
    }

    submit(form) {
        if (!this.submitUrl) {
            return;
        }

        if (form && form.$invalid) {
            form.$setSubmitted();
            angular.forEach(form.$error, (controls) => {
                angular.forEach(controls, (ctrl) => {
                    if (ctrl && typeof ctrl.$setTouched === 'function') {
                        ctrl.$setTouched();
                    }
                });
            });
            this.$timeout(() => {
                const el = document.querySelector('.thesis-form .md-input-invalid')
                    || document.querySelector('.thesis-form');
                if (el && typeof el.scrollIntoView === 'function') {
                    el.scrollIntoView({behavior: 'smooth', block: 'center'});
                }
            });
            return;
        }

        if (this.publishConfirm && Number(this.model.active) === 1) {
            if (!confirm(this.publishConfirm)) {
                return;
            }
        }

        const out = {...this.model};

        const fromDate = (d) => (d instanceof Date && !isNaN(d.getTime())) ? Math.floor(d.getTime() / 1000) : 0;
        out.date = fromDate(out.dateObj);
        out.terminas = fromDate(out.termObj);

        const toSendNumber = (v) => (v === null || v === undefined || v === '' ? '' : String(v));
        out.etatas = toSendNumber(out.etatas);

        delete out.dateObj;
        delete out.termObj;

        const as01 = (v) => (v === 1 || v === '1' || v === true || String(v).toLowerCase() === 'true' || String(v).toLowerCase() === 'on') ? 1 : 0;
        out.publikuota = as01(out.publikuota);

        const fd = new FormData();
        Object.keys(out).forEach((k) => {
            const v = out[k];
            if (v === undefined) {
                return;
            }
            if (v === null) {
                fd.append(k, '');
                return;
            }
            if (typeof v === 'object') {
                return;
            }
            fd.append(k, v);
        });

        const formEl = document.querySelector('.thesis-form');
        const fileInputs = formEl ? formEl.querySelectorAll('input[type="file"][name]') : [];
        Array.prototype.forEach.call(fileInputs, (el) => {
            if (el.files && el.files.length > 0) {
                fd.append(el.name, el.files[0]);
            }
        });

        if (Array.isArray(this.attachments)) {
            this.attachments.forEach((a) => {
                if (a && a.del) {
                    fd.append('deldoc[' + a.name + ']', a.del);
                }
            });
        }
        if (formEl) {
            const filemapInputs = formEl.querySelectorAll('input[name^="filemap["]');
            Array.prototype.forEach.call(filemapInputs, (el) => {
                fd.append(el.name, el.value || '');
            });
        }

        const req = {
            url: this.submitUrl,
            method: 'POST',
            data: fd,
            headers: {'Content-Type': undefined},
            transformRequest: angular.identity,
            responseType: 'json'
        };

        const onOk = (res) => {
            const payload = res && res.data ? res.data : res;
            if (payload && payload.redirect) {
                window.location.assign(payload.redirect);
                return;
            }
            if (payload && payload.message === 'forbidden') {
                alert('Nepavyko išsaugoti - Jūsų sesija pasibaigė. Prašome prisijungti iš naujo.');
                return;
            }
            if (payload && payload.message === 'forbidden_institution') {
                alert('Nepavyko išsaugoti - Jūs neturite teisių pasirinktai institucijai.');
                return;
            }
            if (payload && payload.errors) {
                alert('Nepavyko išsaugoti. Patikrinkite, ar visi privalomi laukai užpildyti.');
            }
        };

        if (typeof this.$scope.basicHttpConfigProcess === 'function') {
            this.$scope.basicHttpConfigProcess(req).then(onOk);
        } else {
            this.$http(req).then(onOk);
        }
    }
}
